import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal, Providers } from 'Components/utility';
const mapState = ({ nav: { location, initErrorStatus, queryString, data } }) => {
    return {
        initErrorStatus,
        queryString,
        location,
        data,
    };
};
const connector = connect(mapState);
const App = ({ initErrorStatus, location, data }) => {
    const { Component, props } = useRouter(location, initErrorStatus, data);
    return (React.createElement(Providers, null,
        React.createElement(Component, { ...props }),
        React.createElement(GeneralModal, null)));
};
export default connector(App);
